import {
  IconWrapper,
  PromotionLabelWrapper,
  PromotionText,
  PromotionTextWrapper,
  PromotionTitle,
  SecondaryText,
  ShortcutButton
} from './PromotionLabel.styles'
import { isString } from '../../../utils'
import {
  IPromotionLabelProps,
  IShortcutButtonDataProps
} from './PromotionLabel.types'
import useId from '../../hooks/useId'
import { ButtonProps } from '../Button'
import { TextProps } from '../Text'

const isButtonProps = (props: unknown): props is ButtonProps => {
  const propsAsButtonProps = props as ButtonProps
  return propsAsButtonProps.onClick !== undefined
}

const isTextProps = (props: unknown): props is TextProps => {
  const propsAsButtonProps = props as TextProps
  return (
    propsAsButtonProps.onClick === undefined &&
    propsAsButtonProps.value !== undefined
  )
}

const ShortcutButtonComponent = (props: IShortcutButtonDataProps) => {
  const { onClick, data, ...restProps } = props
  return <ShortcutButton {...restProps} onClick={() => onClick?.({ data })} />
}

const PromotionLabel = ({
  text,
  icon = {
    iconset: 'cm',
    name: 'CmPromotion'
  },
  showIcon = false,
  type = 'label',
  styles,
  size = 10,
  align = 'center',
  color = 'primary',
  secondaryText = '',
  lines,
  lineHeightAuto = true,
  wrap = false,
  title,
  data,
  showButton = false,
  'data-testid': testid = 'promotion-label'
}: IPromotionLabelProps) => {
  const { getTestId } = useId(testid)
  const iconProps = isString(icon) ? { name: icon } : icon

  let textProps = isString(text) ? { value: text } : text
  textProps = {
    ...textProps,
    lines
  }

  const secondaryTextProps = isString(secondaryText)
    ? { value: secondaryText }
    : secondaryText

  const titleProps = isString(title) ? { value: title } : title

  const iconSize = type === 'detail-extended' ? 25 : size

  return (
    <PromotionLabelWrapper
      align={align}
      sx={styles}
      type={type}
      wrap={wrap}
      data-testid={getTestId()}>
      {showIcon && (
        <IconWrapper
          size={iconSize}
          color={color}
          data-testid={getTestId('icon')}
          {...iconProps}
        />
      )}
      <PromotionTextWrapper type={type}>
        <PromotionTitle {...titleProps} />
        <PromotionText
          size={size}
          color={color}
          type={type}
          lineHeightAuto={lineHeightAuto}
          data-testid={getTestId('text')}
          {...textProps}
        />
      </PromotionTextWrapper>
      {showButton && !!secondaryText && isButtonProps(secondaryTextProps) && (
        <ShortcutButtonComponent {...secondaryTextProps} data={data} />
      )}
      {!!secondaryText && isTextProps(secondaryTextProps) && (
        <SecondaryText
          size={size}
          color={color}
          type={type}
          data-testid={getTestId('text')}
          {...secondaryTextProps}
        />
      )}
    </PromotionLabelWrapper>
  )
}

export default PromotionLabel
